class featureYouTubeVideo {
  constructor(props) {
    const {
      youtubeId,
      videoId,
      loop = true,
      autoplay = true,
      muted = true,
      onProgress,
      onPlayerReady,
      onPlayerStateChange,
    } = props

    // props
    this.youtubeId = youtubeId
    this.videoId = videoId
    this.loop = loop
    this.muted = muted
    this.autoplay = autoplay

    // callbacks
    this.onProgress = onProgress
    this.onPlayerStateChange = onPlayerStateChange
    this.onPlayerReady = onPlayerReady

    // internal
    this.player = null
    this.playerReady = false
    this.progress = 0
    this.timeInterval = 0

    // https://stackoverflow.com/questions/43165089/get-current-state-of-player-youtube-api
    this.playingStates = [
      {
        value: 0,
        label: 'ENDED',
      },
      {
        value: 1,
        label: 'PLAYING',
      },
      {
        value: 2,
        label: 'PAUSED',
      },
      {
        value: 3,
        label: 'BUFFERING',
      },
      {
        value: 5,
        label: 'CUED',
      },
    ]
  }

  createVideo() {
    this.player = new window.YT.Player(this.videoId, {
      height: '390',
      width: '640',
      videoId: this.youtubeId,
      host: 'https://www.youtube-nocookie.com',
      playerVars: {
        playsinline: 1,
        autoplay: this.autoplay,
        controls: 0,
        enablejsapi: 1,
        rel: 0,
        showinfo: 0,
        ecver: 2,
      },
      events: {
        onReady: (e) => this.onPlayerReadyHandler(e),
        onStateChange: (e) => this.onPlayerStateChangeHandler(e),
      },
    })
  }

  onPlayerReadyHandler(event) {
    this.playerReady = true

    this.onPlayerReady(event, this.player)

    if (this.muted) {
      this.mute()
    } else {
      this.unMute()
    }

    if (this.autoplay === 1) {
      this.play()
    }
  }

  onPlayerStateChangeHandler(event) {
    const currentState = this.playingStates.find(
      (item) => item.value === event.data
    )

    this.onPlayerStateChange(event, this.player, currentState)
    clearInterval(this.timeInterval)

    if (this.muted) {
      this.mute()
    } else {
      this.unMute()
    }

    if (event.data === 1) {
      this.updateWhilePlaying()
    } else if (event.data === 0) {
      if (this.loop) {
        this.play()
      }
    }
  }

  updateWhilePlaying() {
    this.timeInterval = setInterval(() => {
      this.emitDurationPercent()
    }, 1000)
  }

  emitDurationPercent() {
    this.progress = Math.round(
      (Number(this.player.getCurrentTime()) /
        Number(this.player.getDuration())) *
        100
    )
    if (typeof this.onProgress === 'function') {
      this.onProgress(this.progress)
    }
  }

  changeMuteState(state) {
    this.muted = state
  }

  stop() {
    if (this.playerReady) {
      this.player.stopVideo()
    }
  }

  play() {
    if (this.playerReady) {
      this.player.playVideo()
    }
  }

  mute() {
    if (this.playerReady) {
      this.player.mute()
      // this.player.setVolume(0)
    }
  }

  unMute() {
    if (this.playerReady) {
      this.player.unMute()
      // this.player.setVolume(100)
    }
  }

  pauseVideo() {
    if (this.playerReady) this.player.pauseVideo()
  }

  loadVideoById(id) {
    if (this.playerReady) this.player.loadVideoById(id)
  }
}
export default featureYouTubeVideo
